
// window.onload = function() {
//     console.log('loaded');
//     document.body.className += " loaded";
// }

jQuery(document).ready(function($) {
  $('body').addClass('loaded');  
});